// extracted by mini-css-extract-plugin
export var layoutContainer = "_7i-0";
export var layoutContainerNoRounding = "_7i-6";
export var layoutContainerOpen = "_7i-5";
export var layoutContainerResizing = "_7i-1";
export var mainContent = "_7i-2";
export var resizeDivider = "_7i-3";
export var slidePanel = "_7i-4";